import { Link } from "react-router-dom";
import { useColorMode, VyLogo, VyLogoPride } from "shared/components/Spor";

export const Logo = () => {
  const { colorMode } = useColorMode();

  const ifJune = new Date().getMonth() === 5; // June is month 5 in JavaScript (0-indexed)
  return (
    <Link to="/" aria-label="Lenke til startsiden">
      {ifJune ? (
        <VyLogoPride display="block" colorScheme="light" width="60px" />
      ) : (
        <VyLogo display="block" colorScheme={colorMode} width="60px" />
      )}
    </Link>
  );
};
